import { makeStyles } from "@material-ui/core";
import { COLORS, SCALES } from "./theme";

export const useStylesLocally = makeStyles({
  root: {
    backgroundColor: COLORS.tertiary_ligthindigo,
    borderRadius: 7,
    width: "15vw",
    height: "5vh",
    fontSize: SCALES.answerFontSize,
    padding: 0,
    border: 0,
    "& .MuiAutocomplete-endAdornment": {
      paddingRight: "0.9vmin",
    },
  },
  listbox: {
    backgroundColor: COLORS.tertiary_lightbackground,
    fontFamily: "GibsonRegular",
    color: "grey",
    "&::-webkit-scrollbar": {
      width: "0.7vmin",
      backgroundColor: "inherit",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: COLORS.little_darker_lightindigo,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: COLORS.primary_navyblue,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: COLORS.primary_navyblue,
    },
  },
  input: {
    color: COLORS.primary_navyblue,
    letterSpacing: "0.2vmin",
  },
  tag: {
    borderRadius: 7,
  },

  textFieldRoot: {
    "& .MuiAutocomplete-inputRoot": {
      fontFamily: "GibsonRegular",
      fontSize: "1.6vmin",
      border: 0,
      width: "100%",
      height: "5vmin",
      paddingLeft: "2vmin",
      paddingRight: "1vmin",
      letterSpacing: "2.3vmin",
    },
    "& .MuiInput-formControl": {
      // border: "2px solid black",
    },

    "& .MuiInput-underline:before": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      borderBottom: 0,
      // borderBottom: "2px solid inherit",
      transition: "",
    },
    "& .MuiInput-underline:after": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      // width: "2vh",
      // height: "2vh",
      borderBottom: 0,
      transition: "",
    },
    "& .MuiInput-underline": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      // width: "6vh",
      // height: "2vh",
      // border: "5px solid blue",
      // transition: "",
      // display: "none",
      // color: "green",
    },

    "& .MuiInput-icon": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
  },

  textFieldRootForMultiSelect: {
    "& .MuiAutocomplete-inputRoot": {
      fontFamily: "GibsonRegular",
      fontSize: "1.6vmin",
      minHeight: "5vh",
      border: 0,
      paddingRight: "2vmin",
      paddingLeft: "2vmin",
      paddingTop: "1vmin",
      paddingBottom: "1vmin",
    },
    "& .MuiInput-formControl": {
      // border: "2px solid black",
    },

    "& .MuiInput-underline:before": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      borderBottom: 0,
      // borderBottom: "2px solid inherit",
      transition: "",
    },
    "& .MuiInput-underline:after": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      // width: "2vh",
      // height: "2vh",
      borderBottom: 0,
      transition: "",
    },
    "& .MuiInput-underline": {
      // borderBottomColor: "green",
      // border: "2px solid black",
      // width: "6vh",
      // height: "2vh",
      // border: "5px solid blue",
      // transition: "",
      // display: "none",
      // color: "green",
    },

    "& .MuiInput-icon": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
  },

  rootForMultiSelect: {
    backgroundColor: COLORS.tertiary_ligthindigo,
    borderRadius: 7,
    width: "15vw",
    minHeight: "5vh",
    fontSize: SCALES.answerFontSize,
    padding: 0,
    border: 0,
    "& .MuiFilledInput-root": {
      backgroundColor: "rgb(214, 218, 231)",
    },
    "& .MuiAutocomplete-endAdornment": {
      paddingRight: "0.9vmin",
    },
    "& .MuiChip-root": {
      fontFamily: "GibsonRegular",
      color: COLORS.primary_navyblue,

      backgroundColor: COLORS.grey_font_cell,
      display: "flex",
      alignItems: "center",
      //   minHeight: "5vh",
    },
  },

  rootForYesNo: {
    "& .PrivateRadioButtonIcon-root-11": {
      "&:hover fieldset": {
        color: "green",
        backgroundColor: "green",
      },
    },
    "& .MuiRadio-root": {
      backgroundColor: "orange",
      border: "2px solid green",
    },
    // backgroundColor: COLORS.secondary_orange,
    "&:hover": {
      backgroundColor: COLORS.tertiary_lightbackground,
    },
    "&:focus": {
      backgroundColor: "yellow",
    },
  },

  formControllLabelRoot: {
    borderRadius: "1vmin",
    paddingRight: "1.1vmin",
    "&:focus": {
      backgroundColor: COLORS.tertiary_ligthindigo,
      border: 0,
      borderRadius: "0.5vmin",
    },
  },
});
